import { useEffect, useState } from "react"
import { useAppSelector } from "../../../../../../hooks/store-hooks"
import { IOcupacao } from "../../../../../../../application/models"
import { useOcupacaoService, useRecortesExtracaoService } from "../../../../../../../use-cases/geo-veles"
import { Autocomplete, debounce, Grid, TextField } from "@mui/material"
// Icon

export const RecorteProfissao = () => {
    // State
    const { ocupacoes, searchTerm } = useAppSelector((state) => state.ocupacao)
    const { openForm, createRecorteExtracaoForm } = useAppSelector((state) => state.recorteExtracao)
    // Use State
    const [selectedProfissao, setSelectedProfissao] = useState<IOcupacao[]>([])
    // Hook
    const {
        setCategoria,
        setSearchTerm,
        searchOcupacoes,
        resetCategoria,
        resetOcupacoes,
        resetSearchTerm
    } = useOcupacaoService()
    const { syncFilterWithForm, removeFilterFromForm } = useRecortesExtracaoService()

    useEffect(() => {
        const profissoesSelecionadas = createRecorteExtracaoForm.fields.Filtros?.profissao || [];

        if (profissoesSelecionadas.length > 0) {
            setSelectedProfissao(profissoesSelecionadas);
        } else {
            setSelectedProfissao([]);
        }
    }, [createRecorteExtracaoForm.fields.Filtros?.profissao]);

    // Filtra as opções para remover os itens já selecionados
    const filteredProfissoes = ocupacoes.filter((ocupacao: IOcupacao) =>
        !selectedProfissao.some((selected: IOcupacao) => selected.cbocodigo === ocupacao.cbocodigo)
    );

    // Functions
    const debouncedSetSearchTerm = debounce((newSearchTerm) => {
        setCategoria('familiasearch')
        setSearchTerm(newSearchTerm);
    }, 500);

    const handleProfissaoSelectionChange = (value: IOcupacao[]) => {
        setSelectedProfissao(value);

        if (value.length > 0) {
            syncFilterWithForm({
                filtro: 'profissao',
                value: value,
                formType: 'create'
            });
        } else {
            removeFilterFromForm({
                filtro: 'profissao',
                formType: 'create'
            });
        }
    }

    // Use Effect
    useEffect(() => {
        if (searchTerm.length > 0) {
            searchOcupacoes()
        }
    }, [searchOcupacoes, searchTerm])

    useEffect(() => {
        resetCategoria()
        resetOcupacoes()
        resetSearchTerm()
    }, [openForm, resetCategoria, resetOcupacoes, resetSearchTerm])

    return (
        <>
            <Grid item xs={11} my={2}>
                <Autocomplete
                    multiple
                    id="tags-standard"
                    options={filteredProfissoes}
                    getOptionLabel={(option) => option.cbodescricao ? `${option.cbocodigo} - ${option.cbodescricao.toUpperCase()}` : ''}
                    sx={{
                        px: 2
                    }}
                    value={selectedProfissao}
                    onInputChange={(event, newInputValue) => {
                        debouncedSetSearchTerm(newInputValue)
                    }}
                    onChange={(event, value) => {
                        handleProfissaoSelectionChange(value);
                    }}
                    noOptionsText={searchTerm.length > 1 ? 'Nenhuma profissão encontrado' : 'Digite o número ou descrição da profissão'}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="outlined"
                            label="Lista de Profissões"
                        />
                    )}
                />
            </Grid>
        </>
    )
}